import React from 'react'
import LevelComponent from '../../level/components/LevelComponent'
import PlayerLevelComponent from '../../level/components/types/PlayerLevelComponent'
import ConnectedComponent from '../../../shared/connecter/ConnectedComponent'
import NextPlayer from '../../players/NextPlayerComponent'
import NewGameSettings from './NewGameSettings'
import EndGameComponent from '../../leaderboards/components/EndGameComponent'
import {connect} from 'react-redux'


class HorizontalLayout extends React.Component {
    render() {
        const {levels, players, settings} = this.props
        const border = 9
        return (
            <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className={'board  ' +settings.theme }>
                        <PlayerLevelComponent players={players}/>
                        {levels.slice(0, border)}
                    </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className={'board  ' +settings.theme }>
                        <PlayerLevelComponent players={players}/>
                        {levels.slice(border, levels.length)}
                    </div>
                </div>
            </div>
        )
    }
}

class VerticalLayout extends React.Component {
    render() {
        const {levels, players, settings} = this.props
        return (<div className={'board  ' +settings.theme }>
            <PlayerLevelComponent players={players}/>
            {levels}
        </div>)
    }
}

function Board(props) {
    const {layout, players, levels, settings} = props
    return layout === 'vertical' ?
        <VerticalLayout players={players} settings={settings} levels={levels}/> :
        <HorizontalLayout players={players} settings={settings} levels={levels}/>
}


function getTotals(players) {
    return players.toJSON().map(player => {
        const score = player.scoreBoard.reduce((prev, v)=> {
            return prev + v.value
        }, 0)
        const numberScore = player.scoreBoard.reduce((prev, v)=> {
            return prev + (/^nums/.test(v.id) ? v.value : 0 )
        }, 0)
        return {...player, total: score + (numberScore >= 60 ? 35 : 0)}
    }).sort((a, b) => a.total < b.total)
}


export default connect(store => {
    return {
        layout: store.settings.layout
    }
})(class extends ConnectedComponent {

    constructor() {
        super()
        this.subscribe('players')
        this.subscribe('settings')
        this.subscribe('game')
    }

    render() {
        const settings = this.store.settings.toJSON()
        const levels = this.store.levels.toJSON().map(level => <LevelComponent settings={settings} key={level.id}
                                                                               level={level}/>)
        const players = this.store.players.toJSON()
        const layout = this.props.layout
        const status = this.store.game.get('status')

        return (

                <div className="container-fluid">
                    { status === 'started' || status === 'ended' ? <Board settings={settings} levels={levels} players={players} layout={layout}/> : null }
                    { status === 'started' ? <NextPlayer /> : null }
                    { status === 'picking' ? <NewGameSettings /> : null}
                    { status === 'ended' ? <EndGameComponent /> : null}
                </div>
        )
    }

    componentWillUpdate() {
        const {players, levels} = this.store;
        const played = players.toJSON().reduce((prev, player)=> {
            return prev + player.scoreBoard.length
        }, 0)

        const totalLevel = levels.length - 5
        if (played > 0 && played === totalLevel * players.length) {

            const collection = this.store.playedGamesHistory
            const totals = getTotals(this.store.players)
            const prev = collection.get(this.store.game.id)
            const prevDate = prev ? prev.get('date') : null
            collection.remove(prev)
            collection.add({
                id: this.store.game.id,
                date: prevDate || new Date().getTime(),
                players: totals,
                winner: totals[0]
            })

            this.store.game.set('status', 'ended')
        }
    }
})


// WEBPACK FOOTER //
// ./src/game/board/components/BoardComponent.jsx